import React, {useEffect, useState} from "react";
import {Modal, Button} from 'react-bootstrap';
import {errorMesg} from "./../../../Pages/Toaster";
import {UploadCSVLeadAPI, getUploadedCSVListAPI} from "./../../../API/Admin/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import SampleCSV from "./../../../Public/sample-upload-load.csv";
import { Link } from "react-router-dom";


const UploadLeads = () =>{

	const [file, setFile] = useState(null);
    const [isuploaded, setIsUploaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filelist, setFileList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [btnloader, setBtnLoader] = useState(false);
    const [campaignlist, setCampaignList] = useState([]);
    const [campaign, setCampaign] = useState(null);
    const [timeslot, setTimeSlot] = useState("");

    const perpagedata = 20;

    useEffect(() => {

        getUploadedCSVListAPI(setFileList, setLoading, setPageCount, currentPage, perpagedata, setCampaignList);

        //console.log('>>>>'+industrylist);

    }, [isuploaded]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleUploadLeadToggle = () =>{
        setShowPopup(!showPopup);
    }

    const handleTimeslot = (e) =>{
        setTimeSlot(e.target.value);
    }

    /*const handlePopToggle = () =>{
        setShowPopup(!showPopup);
    }*/

    const handlePopupClose = () =>{
        setShowPopup(false);
    }

    const handleUploadCSVFile = (event) =>{
        setFile(event.target.files[0]);
    }

    const handleSelectCampaign = (event) =>{
        setCampaign(event.target.value);
    }

    const resetUserForm = () =>{
        setFile(null);
    }

    const btnUploadNow = () =>{

        if(!file)
        {
            console.log('file upload');
            errorMesg('Please upload a csv file here');
            return;
        }
        else if(campaign === "" || campaign === null)
        {
            errorMesg("Please select a campaign");
            return;
        }
        else if(timeslot === "" || timeslot === null)
        {
            errorMesg("Please select a timeslot");
            return;
        }

        const formData = new FormData();
        formData.append('csvfile', file);
        formData.append('campaignid', campaign);
        formData.append('timeslot', timeslot);
        
        //console.log('params======' + JSON.stringify(params));

        UploadCSVLeadAPI(formData, setBtnLoader, setIsUploaded, resetUserForm, setShowPopup, setFileList);
    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

				<div className="row">
					<div className="col-md-12">

						<div className="page-header">
							<div className="row align-items-center">
								<div className="col-8">
									<h4 className="page-title">Uploaded Leads List</h4>
								</div>
								<div className="col-4 text-end">
									<div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
										<div></div>
                                        <Link to={SampleCSV} target="_blank" className="btn btn-primary me-2">
                                            <i className="ti ti-download me-2"></i>Download Sample
                                        </Link>
                                        <button type="button" className="btn btn-primary" onClick={handleUploadLeadToggle}>
                                            <i className="ti ti-upload me-2"></i>Upload Lead
                                        </button>
									</div>
								</div>
							</div>
						</div>

						<div className="card">

							<div className="card-body">

								<div className="d-flex align-items-center justify-content-between flex-wrap">
									<div className="dropdown">
										
									</div>
									<div className="d-flex align-items-center flex-wrap row-gap-2">
										
									</div>
								</div>

								<div className="table-responsive custom-table">
									
									<table className="table" id="faqlist">
										<thead className="thead-light">
											<tr>
												<th>File Name</th>
												<th>Total Leads</th>
												<th>Valid Leads</th>
												<th>Duplicate Leads</th>
                                                <th>Created On</th>
											</tr>
										</thead>
										<tbody>
									
										{loading ?
											<tr>
												<td colSpan="5">
													<Loader />
												</td>
											</tr>
										:
											(filelist && filelist.length > 0  ? 
												( filelist.map(filedata => 
													(
											
														<tr key={filedata.id}>															
															<td>{filedata.filename}</td>
															<td>{filedata.totalcount}</td>
															<td>{filedata.validcount}</td>
															<td>{filedata.duplicatecount}</td>
                                                            <td>{moment(filedata.created_at).format('DD-MM-YYYY h:mm:ss')}</td>
														</tr>
													)
												))
											
											:
										
												<tr>
													<td colSpan="5">
														<p>No record found...</p>
													</td>
												</tr>
											)
										}
									
										</tbody>
									</table>
									
								</div>
								

							</div>
						</div>
						
						{ pagecount > 1 ?
						<div className="row pagination-section">
							<nav>
								<Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
							</nav>
						</div>
						:
							<></>
						}

					</div>
				</div>

			</div>
        </div>
		
        {/*<div className={showPopup ? 'modal fade show' : 'modal fade' } id="exampleModalScrollable2" tabindex="-1" aria-labelledby="exampleModalScrollable2" data-bs-keyboard="false" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="staticBackdropLabel2">Upload Leads Using CSV</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handlePopupClose}></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label htmlFor="campaign" className="form-label">Campaign*</label>
                            <select className="form-control" name="campaign" onChange={handleSelectCampaign}>
                                <option value="">Select Campaign</option>
                                {campaignlist && campaignlist.length > 0 ?
                                    (campaignlist.map(campaign =>
                                        (
                                            <option value={campaign.id} key={campaign.id}>{campaign.name}</option>
                                        )
                                    ))
                                :
                                    <></>    
                                }
                            </select>
                        </div>

                        <div class="mb-3">
                            <label htmlFor="csvfile" className="form-label">Upload CSV File*</label>
                            <input className="form-control" type="file" accept=".csv" onChange={handleUploadCSVFile} required="" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>

                        {btnloader ?
                            <button type="button" class="btn btn-primary"> 
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </button>
                        :
                            <button type="button" class="btn btn-primary" onClick={btnUploadNow}> Upload Now </button>
                        }
                    </div>
                </div>
            </div>
        </div>*/}
		<Modal show={showPopup} onHide={handlePopupClose}>
        
            <Modal.Header closeButton>
    
                <Modal.Title>Upload Leads Using CSV</Modal.Title>
    
            </Modal.Header>
            
            <Modal.Body>
                <div class="mb-3">
                    <label htmlFor="campaign" className="form-label">Campaign*</label>
                    <select className="form-control" name="campaign" onChange={handleSelectCampaign}>
                        <option value="">Select Campaign</option>
                        {campaignlist && campaignlist.length > 0 ?
                            (campaignlist.map(campaign =>
                                (
                                    <option value={campaign.id} key={campaign.id}>{campaign.name}</option>
                                )
                            ))
                        :
                            <></>    
                        }
                    </select>
                </div>

                <div class="mb-3">
                    <label htmlFor="timeslot" className="form-label">Timeslot*</label>
                    <select className="form-control" name="timeslot" onChange={handleTimeslot}>
                        <option value="">Select Slot</option>
                        <option value="1">Slot-I (07:00 - 08:00)</option>
                        <option value="2">Slot-II (10:00 - 11:00)</option>
                        <option value="3">Slot-III (12:00 - 13:00)</option>
                        <option value="4">Slot-IV (16:00 - 17:00)</option>                        
                    </select>
                </div>

                <div class="mb-3">
                    <label htmlFor="csvfile" className="form-label">Upload CSV File*</label>
                    <input className="form-control" type="file" accept=".csv" onChange={handleUploadCSVFile} required="" />
                </div>
    
            </Modal.Body>
    
            <Modal.Footer>
                <Button variant="secondary" onClick={handlePopupClose}> Close </Button>
    
                {btnloader ?
                    <Button variant="primary"> 
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </Button>
                :
                    <Button variant="primary" onClick={btnUploadNow}> Upload Now </Button>
                }
    
            </Modal.Footer>
        </Modal>

        <ToastContainer />
    </div>
    )
}

export default UploadLeads;
